import { render, staticRenderFns } from "./creatives.vue?vue&type=template&id=5742eb22"
import script from "./creatives.vue?vue&type=script&lang=js"
export * from "./creatives.vue?vue&type=script&lang=js"
import style0 from "./creatives.vue?vue&type=style&index=0&id=5742eb22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports